import React, { useState } from "react";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import LoadingButton from "components/LoadingButton";

/**
 * Modal that displays JSON data with a dark background and a copy-to-clipboard button.
 *
 * Props:
 *  - show    : boolean
 *  - onHide  : () => void
 *  - data    : string (raw JSON string)
 *  - title   : string (default "Response Data")
 */
const JsonViewerModal = ({ show, onHide, data, title = "Response Data" }) => {
  const [copied, setCopied] = useState(false);

  let formatted = "";
  try {
    formatted =
      typeof data === "string"
        ? JSON.stringify(JSON.parse(data), null, 2)
        : JSON.stringify(data, null, 2);
  } catch {
    formatted =
      typeof data === "string" ? data : JSON.stringify(data || "", null, 2);
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(formatted).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <ConfirmationModal
      dialogClassName="modal-md"
      show={show}
      onHide={onHide}
      centered
      size="lg"
      title={title}
      confirmButtonLabel="Close"
      onConfirm={onHide}
    >
      <div
        style={{
          background: "#1e1e1e",
          maxHeight: "70vh",
          overflow: "auto",
          padding: "1rem",
        }}
      >
        <div className="d-flex justify-content-end mb-2">
          <LoadingButton
            variant="primary"
            size="sm"
            isLoading={false}
            onClick={handleCopy}
          >
          {copied ? (
            <>
              <i className="uil uil-check"></i> Copied
            </>
          ) : (
            <>
              <i className="uil uil-copy"></i> Copy
            </>
          )}
          </LoadingButton>
        </div>
        <pre
          style={{
            color: "#d4d4d4",
            fontFamily: "'Courier New', Courier, monospace",
            fontSize: "0.85rem",
            margin: 0,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {formatted}
        </pre>
      </div>
    </ConfirmationModal>
  );
};

export default JsonViewerModal;
